var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row list-view"
  }, [_c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('header', {
    staticClass: "row p12 list-view-filter",
    staticStyle: {
      "background": "#f2f2f2"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "h-filter"
  }, [_c('div', {
    staticClass: "h-filter-item"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Type")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.discountType,
      expression: "search.discountType"
    }],
    staticClass: "mr6 h40",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.search, "discountType", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    staticClass: "option-all",
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Type")]), _c('option', {
    attrs: {
      "value": "percentage"
    }
  }, [_vm._v("Percentage")]), _c('option', {
    attrs: {
      "value": "fix_amount"
    }
  }, [_vm._v("Fix Amount")])])]), _c('div', {
    staticClass: "h-filter-item"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.status,
      expression: "search.status"
    }],
    staticClass: "mr6 h40",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    staticClass: "option-all",
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Status")]), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])])]), _c('div', {
    staticClass: "h-filter-item"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Daterange")]), _c('date-picker', {
    staticStyle: {
      "width": "200px",
      "padding": "0"
    },
    attrs: {
      "value-type": "format",
      "format": "YYYY-MM-DD",
      "range": "",
      "placeholder": "Select daterange"
    },
    model: {
      value: _vm.search.dateRange,
      callback: function ($$v) {
        _vm.$set(_vm.search, "dateRange", $$v);
      },
      expression: "search.dateRange"
    }
  })], 1), _c('div', {
    staticClass: "h-filter-item"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Search")]), _c('div', {
    staticClass: "search-box mr0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.search,
      expression: "search.search"
    }],
    attrs: {
      "type": "search",
      "autocomplete": "off",
      "placeholder": "Search",
      "id": "search"
    },
    domProps: {
      "value": _vm.search.search
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searchItem.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.search, "search", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "h-filter-item"
  }, [_c('div', {
    staticClass: "filter-action filter-af"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm ah",
    on: {
      "click": _vm.searchItem
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search ")]), _vm.checkoutPermission('CREATE_PRODUCT_DISCOUNT') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'CreateProductDiscount'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm ah"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New ")])]) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "table-control"
  }, [_c('table', {
    staticClass: "table wh800",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w70 txt-center"
  }, [_vm._v("No")]), _c('th', [_vm._v("Name")]), _c('th', [_vm._v("Description")]), _c('th', {
    staticClass: "txt-right"
  }, [_vm._v("Discount")]), _c('th', {
    staticClass: "txt-left"
  }, [_vm._v("Dis. Type")]), _c('th', [_vm._v("Start Date")]), _c('th', [_vm._v("End Date")]), _c('th', {
    staticClass: "w100 txt-center"
  }, [_vm._v("Status")]), _vm.checkoutPermission('UPDATE_PRODUCT_DISCOUNT') || _vm.checkoutPermission('DELETE_PRODUCT_DISCOUNT') ? _c('th', {
    staticClass: "w100 txt-center"
  }, [_vm._v(" Action ")]) : _vm._e()])]), _vm.checkoutPermission('LIST_PRODUCT_DISCOUNT') ? _c('tbody', _vm._l(_vm.data.discounts, function (item, index) {
    var _vm$data$pagination$n, _vm$data$pagination;
    return _c('tr', {
      key: (item, index),
      staticClass: "hover-list"
    }, [_c('td', {
      staticClass: "txt-center"
    }, [_vm._v(_vm._s((_vm$data$pagination$n = (_vm$data$pagination = _vm.data.pagination) === null || _vm$data$pagination === void 0 ? void 0 : _vm$data$pagination.no[index]) !== null && _vm$data$pagination$n !== void 0 ? _vm$data$pagination$n : 0))]), _c('td', [_vm._v(_vm._s(item.name))]), _c('td', [_vm._v(_vm._s(item.description || "N/A"))]), _c('td', {
      staticClass: "txt-right"
    }, [item.discountType == 'fix_amount' ? _c('span', [_vm._v(" " + _vm._s(_vm.$helper.formatPrice(item.discountValue)) + " ")]) : _vm._e(), item.discountType == 'percentage' ? _c('span', [_vm._v(" " + _vm._s(_vm.$helper.formatNumber(item.discountValue)) + "% ")]) : _vm._e()]), _c('td', {
      staticClass: "txt-left"
    }, [item.discountType == 'fix_amount' ? _c('span', [_vm._v("Fixed amount")]) : _vm._e(), item.discountType == 'percentage' ? _c('span', [_vm._v("Percentage")]) : _vm._e()]), _c('td', [_vm._v(_vm._s(_vm.$helper.formatDate(item.startDate)))]), _c('td', [_vm._v(_vm._s(_vm.$helper.formatDate(item.endDate)))]), _c('td', {
      staticClass: "txt-center"
    }, [item.status == 'active' ? _c('span', {
      staticClass: "txt-success"
    }, [_vm._v(" Active ")]) : _c('span', {
      staticClass: "txt-danger"
    }, [_vm._v("Inactive")])]), _c('td', {
      staticClass: "txt-center"
    }, [_vm.checkoutPermission('UPDATE_PRODUCT_DISCOUNT') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'EditProductDiscount',
          query: {
            id: item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-info btn-xs h36"
    }, [_c('i', {
      staticClass: "fa fa-pen"
    })])]) : _vm._e(), _vm.checkoutPermission('DELETE_PRODUCT_DISCOUNT') ? _c('button', {
      staticClass: "btn btn-danger btn-xs h36 ml3",
      on: {
        "click": function ($event) {
          return _vm.popupModal(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1)]);
  }), 0) : _vm._e()]), _vm.isFetching ? _c('TableLoading') : _vm._e(), _vm.isNoData ? _c('NoItem') : _vm._e()], 1), _c('div', {
    staticClass: "total ph12"
  }, [_c('div', {
    staticClass: "ul-xl-li go-left"
  }, [_vm._v("Total : " + _vm._s(_vm.data.pagination.total))]), _vm.data.pagination.totalPage > 0 ? _c('Pagination', {
    attrs: {
      "pagination": _vm.data.pagination.totalPage
    }
  }) : _vm._e()], 1)])]), _vm.display.modal.delete.show ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal-md"
  }, [_vm._m(1), _vm._m(2), _c('div', {
    staticClass: "modal-footer border-top"
  }, [!_vm.isDeleting ? _c('button', {
    staticClass: "btn btn-info btn-xs go-right",
    on: {
      "click": _vm.deleteItem
    }
  }, [_vm._v(" Yes ")]) : _c('button', {
    staticClass: "btn btn-info btn-xs go-right"
  }, [_vm._v("Loading...")]), _c('button', {
    staticClass: "btn btn-light-secondary btn-xs mr12 go-right",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" No ")])])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "go-left",
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('b', [_vm._v("All Discount")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-header border-bottom txt-info"
  }, [_c('span', {
    staticClass: "txt-sm"
  }, [_vm._v("Delete")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "hidden",
      "padding": "16px"
    }
  }, [_c('span', [_vm._v("Do you want to delete this record?")])]);

}]

export { render, staticRenderFns }